import { useCallback, useEffect, useState } from 'react';
import type { ToastProps } from 'react-bootstrap';

export interface ToastConfig extends ToastProps {}

export const useToastMessage = () => {
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState<
    React.ReactElement | string | null
  >(null);
  const [autoHide, setAutoHide] = useState(true);

  const setToast = useCallback(
    (message: React.ReactElement | string, config?: ToastConfig) => {
      setToastMessage(message);
      setShowToast(true);
      setAutoHide(config?.autohide !== false);
    },
    [],
  );

  const closeToast = useCallback(() => setShowToast(false), []);

  useEffect(() => {
    if (showToast && autoHide) {
      const timeId = setTimeout(() => {
        closeToast();
      }, 5000);
      return () => clearTimeout(timeId);
    }
  }, [showToast, autoHide]);

  return {
    closeToast,
    showToast,
    toastMessage,
    setToast,
  };
};
